'use client';

import type {
  EcomFooterProps,
  HeaderV3Props,
  LayoutV3Props,
  PdpHeaderProps,
} from '@jouzen/ecom-components';
import { PageLayoutV3 as Layout } from '@jouzen/ecom-components';

import usePageView from '@/analytics/hooks/usePageView';

import { usePageLayout } from './hooks/usePageLayout';

export interface HeaderProps extends Partial<HeaderV3Props> {
  isCarouselInView?: PdpHeaderProps['isCarouselInView'];
}

export interface PageLayoutV3Props
  extends Omit<
    LayoutV3Props,
    | 'mainLabel'
    | 'footerProps'
    | 'headerProps'
    | 'eyebrowProps'
    | 'footnotesProps'
  > {
  readonly pageName: string;
  readonly footerProps?: Partial<EcomFooterProps>;
  readonly headerProps?: Partial<HeaderProps>;
  readonly hideFooter?: boolean;
  readonly hideHeader?: boolean;
}

const PageLayoutV3 = ({
  children,
  className = '',
  pageName,
  containerProps: parentContainerProps,
  footerProps: parentFooterProps,
  headerProps: parentHeaderProps,
  hideFooter = false,
  hideHeader = false,
  Header,
}: PageLayoutV3Props) => {
  const {
    containerProps,
    eyebrowProps,
    footnotesProps,
    headerProps,
    footerProps,
    observeNode,
  } = usePageLayout({
    parentContainerProps,
    parentFooterProps,
    parentHeaderProps,
  });

  usePageView(pageName);

  const _header = Header ? { Header } : undefined;

  return (
    <div data-cy="page-layout-v3" ref={observeNode}>
      <Layout
        className={className}
        containerProps={containerProps}
        eyebrowProps={eyebrowProps!}
        footnotesProps={footnotesProps!}
        footerProps={footerProps}
        headerProps={headerProps as HeaderV3Props}
        mainLabel="mainLabel"
        hideFooter={hideFooter}
        hideHeader={hideHeader}
        {..._header}
      >
        {children}
      </Layout>
    </div>
  );
};

export default PageLayoutV3;
